import * as types from '../mutation-types';
import axios from 'axios'
const state = {
    ip: {},
	location: {}
}

const actions = {
	fetchUserIp({ commit }) {
		return axios.get("https://jsonip.com/").then(response => {
            commit(types.STORE_USER_IP, response.data)
            return response.data
		})
	},
	
	getLocation({ commit }, { lat, lon }) {
		return axios.get("https://us1.locationiq.com/v1/reverse.php", {
			params:{
				key: "pk.44866616587961ddc4b86e3a1b866472",
				lat, 
				lon,
				format: "json"
			}
		}).then(response => {
            commit(types.STORE_LOCATION, response.data)
            return response.data
		})
	},
}

const mutations = {
	[types.STORE_USER_IP](state, response) {
		state.ip = response.ip;
    },
	[types.STORE_LOCATION](state, response) {
		state.location = response;
    },
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}

